import { render, staticRenderFns } from "./problem-alerter.vue?vue&type=template&id=4cc1b570&"
import script from "./problem-alerter.component.ts?vue&type=script&lang=js&"
export * from "./problem-alerter.component.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/3/gateway/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc1b570')) {
      api.createRecord('4cc1b570', component.options)
    } else {
      api.reload('4cc1b570', component.options)
    }
    module.hot.accept("./problem-alerter.vue?vue&type=template&id=4cc1b570&", function () {
      api.rerender('4cc1b570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/problem-alerter/problem-alerter.vue"
export default component.exports